<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequired="{{isRequired}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="手机号码" 
    innerValue="{{innerValue}}"
    isDisable="{{isPhoneDisable}}"
  >
    <es-field placeholder="请填写手机号" wx:model="{{innerValue}}" bind:focus="phoneFocus" slot="input"/>
  </from-item>

</template>

<script>
import { watch } from "@mpxjs/core";

  import { createComponent } from '@didi/es-mpx-creator'
  import { AES_ECB_DECRYPT } from '@/common/crypto'
  import { hasRequired } from '@/utils'
  createComponent({
    classes: [],
    data: {
      innerValue:''
    },
    props: {
      userDetail:{
        type: Object,
        value: {}
      },
      value:{
        type: String,
        value: ''
      },
      isAddPage:{
        type: Boolean,
        value: true
      },
      isPhoneDisable:{
        type: Boolean,
        value: false
      },
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isShow:{
        type: Boolean,
        value: false
      },
      item:Object,
      selectedCardList:Array,
      isNeedCard:Boolean,
    },
    computed: {
      isRequired() {
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      },
      phoneNumber() {
        return AES_ECB_DECRYPT(this.userDetail?.mobile_no || '')
      }
    },
    methods: {
      //联系电话输入框聚焦
      phoneFocus() {
        this.$trigger( 'phone-focus' )
      },
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      phoneNumber(val) {
        this.innerValue = val
      },
      //将数据回传
      innerValue(newValue) {
        this.$trigger( 'input', {value:newValue} )
      },
    },
    mounted() {
      this.innerValue = this.isAddPage ? '' : this.phoneNumber
    }
  })
</script>

<style lang='stylus' scoped>
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'from-item': './from-item'
    }
  }
</script>

